import produce from 'immer';
// Action types
import {
  SEARCH_CHANGE_VALUE,
  SEARCH_SET_FILTER,
  SEARCH_RESET_FILTER,
} from 'constants/actionTypes';

const initialState = {
  search: '',
  filter: {
    type: '',
    query: ''
  }
};

// Reducers
// ------------------------------------------------------- //
export const searchReducer = produce((draft, action) => {
  switch (action.type) {
    case SEARCH_CHANGE_VALUE:
      draft.search = action.payload.search
      return;
    case SEARCH_SET_FILTER:
      console.log('check set filter', action.payload)
      draft.filter.type = action.payload.type
      draft.filter.query = action.payload.query
      return;
    case SEARCH_RESET_FILTER:
      draft.filter = {
        type: '',
        query: ''
      }
      return;
    default:
  }
}, initialState);

export default searchReducer;

// Action Creators
// ------------------------------------------------------- //
export const setSearch = payload => ({
  type: SEARCH_CHANGE_VALUE,
  payload
});

export const setFilter = payload => ({
  type: SEARCH_SET_FILTER,
  payload
})

export const resetFilter = payload => ({
  type: SEARCH_RESET_FILTER,
  payload
})

// Side Effects
// ------------------------------------------------------- //

// Selectors
// ------------------------------------------------------- //



// WEBPACK FOOTER //
// ./src/store/modules/db/search/searchReducer.js